// Start the parallax effect on main banner
/*;(function ($, window, document, undefined) {
    'use strict';

    $('.btn-scroll-down').on('click', function () {
        $('html, body').animate({
            scrollTop: $(window).height()
        }, 600);
        return false;
    });

    if ($('.homepage-scene').length) {
        if ($(window).width() > 767) {
            $('.homepage-scene').each(function () {
                var items = $(this).find('.images-wrapper');

                items.each(function () {
                    var id = $(this).attr('id');
                    var scene = document.getElementById(id);
                    var parallaxInstance = new Parallax(scene, {
                        relativeInput: false,
                        clipRelativeInput: false,
                        calibrationThreshold: 100,
                        calibrationDelay: 500,
                        supportDelay: 500,
                        calibrateX: true,
                        calibrateY: false,
                        invertX: true,
                        invertY: true,
                        limitX: false,
                        limitY: false,
                        scalarX: 5.0,
                        scalarY: 5.0,
                        frictionX: 0.1,
                        frictionY: 0.1,
                        originX: 0.5,
                        originY: 0.5,
                        hoverOnly: true
                    });
                });
            });
        }
    }

    function bannerSliderHeight() {
        if ($('.banner-slider-wrap .container').length) {
            var contentH = $('.banner-slider-wrap .container').outerHeight();
            var winH = $(window).height();
            var bannerH = winH > (contentH + 200) ? winH : (contentH + 200);
            $('.banner-slider-wrap .slider-banner').css('height', bannerH);
        }
    }


    $(window).on('load resize', function () {
        bannerSliderHeight();
    });


    window.addEventListener("orientationchange", function () {
        bannerSliderHeight();
    });

})(jQuery, window, document);*/

// Start TEAM carousel
jQuery(function(){
  jQuery(document).ready( function() {
	var owl = jQuery(".authors-carousel");

	owl.owlCarousel({
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
		items: 2,
    responsive:{
        0:{
            items:2,
            nav:true
        },
        600:{
            items:2,
            nav:true
        },
        1000:{
            items:4,
            nav:true,
            loop:true
        }
    },
		nav : true,
		dots: false,
		navText : [
			'<img src="https://www.multi-consult.com/wp-content/themes/multiconsult2015/dist/images/carousel-prev.png" />',
			'<img src="https://www.multi-consult.com/wp-content/themes/multiconsult2015/dist/images/carousel-next.png" />'
		]
	});
});

});

// SMOOTH SCROOL
jQuery('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname
    ) {
      // Figure out element to scroll to
      var target = jQuery(this.hash);
      target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        jQuery('html, body').animate({
          scrollTop: target.offset().top - 100
        }, 1000, function() {
        });
      }
    }
  });

jQuery(function(){
  var waypointHome = new Waypoint({
    element: document.getElementById('scene1'),
    handler: function(direction) {
      jQuery('.navbar .menu-item.current-menu-item').removeClass('current-menu-item');
      jQuery('.menu-item-9').addClass('current-menu-item');
    },
    offset: '10%'
  });

  var waypointAbout = new Waypoint({
    element: document.getElementById('about'),
    handler: function(direction) {
      jQuery('.navbar .menu-item.current-menu-item').removeClass('current-menu-item');
      jQuery('.menu-item-12').addClass('current-menu-item');
    },
    offset: '10%'
  });

  var waypointTeam = new Waypoint({
    element: document.getElementById('team'),
    handler: function(direction) {
      jQuery('.navbar .menu-item.current-menu-item').removeClass('current-menu-item');
      jQuery('.menu-item-13').addClass('current-menu-item');
    },
    offset: '10%'
  });

  var waypointBusinessExpander = new Waypoint({
    element: document.getElementById('business-expander'),
    handler: function(direction) {
      jQuery('.navbar .menu-item.current-menu-item').removeClass('current-menu-item');
      jQuery('.menu-item-14').addClass('current-menu-item');
    },
    offset: '10%'
  });

  var waypointContattaci = new Waypoint({
    element: document.getElementById('contattaci'),
    handler: function(direction) {
      jQuery('.navbar .menu-item.current-menu-item').removeClass('current-menu-item');
      jQuery('.menu-item-15').addClass('current-menu-item');
    },
    offset: '10%'
  });
});

jQuery('.navbar .nav-link').click(function() {
  jQuery('.navbar .menu-item.current-menu-item').removeClass('current-menu-item');
  jQuery(this).parent().addClass('current-menu-item');
});
